// src/api/userAPI.js
import axiosInstance from '../utils/axios';

const authAPI = {
    login: (username, password) => axiosInstance.post("/login", { username, password }),
    register: (username, password) => axiosInstance.post("/register", { username, password }),
    logout: () => axiosInstance.post("/logout"),
    profile: () => axiosInstance.get("/profile"),
};

export default authAPI;